import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import Image from "next/image";
import { Carousel } from "src/components/Carousel/Carousel";
import { color } from "src/styles/globals";
import styled from "styled-components";

export const Container = styled.div`
  padding: 16px;
  padding-bottom: 40px;
  background-color: ${color.charcoal01};
`;

export const BannerContainer = styled.div`
  display: flex !important;
  justify-content: center;
  align-items: center;
  padding: 0 8px;
`;

export const BannerSlider = () => {
  const { lg } = useBreakpoint();

  const bannerUrls = [
    "https://static.easysunday.com/retail/affiliate/content/register-banner-01.png",
    "https://static.easysunday.com/retail/affiliate/content/register-banner-02.png",
    "https://static.easysunday.com/retail/affiliate/content/register-banner-03.png",
    "https://static.easysunday.com/retail/affiliate/content/register-banner-04.png",
    "https://static.easysunday.com/retail/affiliate/content/register-banner-05.png",
  ];

  // work around: carousel bug display last item first when show 2 items per slide on center mode
  const bannerUrlsDesktop = [...bannerUrls.slice(1), bannerUrls[0]];

  return (
    <Container id="banner-slider">
      <Carousel
        itemsLength={bannerUrls.length}
        activeDotColor={color.carrotOrange03}
        inactiveDotColor={color.charcoal03}
        mobileSlidesPerRow={1}
        desktopItemWidth={359}
        arrowSize={40}
        arrowIconSize={24}
        containerWidthOffset={80}
        arrowMargin={-8}
        slickDotMarginTop={32}
        centerMode
      >
        {(lg ? bannerUrlsDesktop : bannerUrls).map((bannerUrl) => (
          <BannerContainer key={bannerUrl}>
            <Image src={bannerUrl} alt="aff-banner" width={343} height={343} />
          </BannerContainer>
        ))}
      </Carousel>
    </Container>
  );
};
